function openCartDrawer() {
  document.querySelector(".cart-drawer").classList.add("cart-drawer--active");
  document.querySelector("body").classList.add("cart-drawer-open");
}

function closeCartDrawer() {
  document.querySelector(".cart-drawer").classList.remove("cart-drawer--active");
  document.querySelector("body").classList.remove("cart-drawer-open");
}

function updateCartItemCounts(count) {
  document.querySelectorAll(".cart-count").forEach((el) => {
    el.textContent = count;
  });
}

async function updateCartDrawer() {
  const res = await fetch("/?section_id=cart-drawer");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;

  const newBox = html.querySelector(".cart-drawer").innerHTML;

  document.querySelector(".cart-drawer").innerHTML = newBox;

  addCartDrawerListeners();
}

function addCartDrawerListeners() {
  // Update quantities
  document
    .querySelectorAll(".cart-drawer .quantity-selector button.quantity-change")
    .forEach((button) => {
      button.addEventListener("click", async () => {
        classes = button.classList;
        // console.log("classes", classes);

        // Get line item key
        const rootItem = button.parentElement.parentElement.parentElement.parentElement;
        const key = rootItem.getAttribute("data-line-item-key");

        // Get new quantity
        const currentQuantity = Number(
          button.parentElement.querySelector("input").value
        );
        const isUp = button.classList.contains(
          "quantity-plus"
        );
        const toRemove = button.classList.contains (
          "quantity-remove"
        );
        const newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1;
                  
        // Ajax update
        const res = await fetch("/cart/update.js", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [key]: newQuantity } }),
        });
        const cart = await res.json();

        updateCartItemCounts(cart.item_count);

        // Update cart
        updateCartDrawer();
      });
    });

  document.querySelectorAll('button.quantity-remove')
    .forEach((button) => {
      button.addEventListener("click", async () => {
      // e.preventDefault();

      // Get line item key
      const rootItem = button.parentElement.parentElement.parentElement.parentElement;
      const key = rootItem.getAttribute("data-line-item-key");
                        
      // Ajax update\
      const res = await fetch("/cart/update.js", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates: { [key]: 0 } }),
      });
      const cart = await res.json();

      updateCartItemCounts(cart.item_count);

      // Update cart
      updateCartDrawer();
    });
  });

  document.querySelector(".cart-drawer-box").addEventListener("click", (e) => {
    e.stopPropagation();
  });

  document
    .querySelectorAll(".cart-drawer-close")
    .forEach((el) => {
      el.addEventListener("click", () => {
        // console.log("closing drawer");
        closeCartDrawer();
      });
    });
}

addCartDrawerListeners();

document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    // Submit form with ajax
    await fetch("/cart/add", {
      method: "post",
      body: new FormData(form),
    });

    // Get cart count
    const res = await fetch("/cart.js");
    const cart = await res.json();
    updateCartItemCounts(cart.item_count);

    // Update cart
    await updateCartDrawer();

    // Open cart drawer
    openCartDrawer();
  });
});

// Open cart drawer
document.querySelectorAll('a[href="/cart"]').forEach((a) => {
  a.addEventListener("click", (e) => {
    e.preventDefault();
    openCartDrawer();
  });
});



jQuery( document ).ready( function( $ ) {

  // Cart drawer upsell
  $('.cart-drawer-items').on('click', '.combo-box button', function(e) {
    e.preventDefault();
    var upsellId = $( this ).closest( '.upsell' ).data( 'upsell_id' );
    console.log('upsell clicked', upsellId);
    
    CartJS.addItem(upsellId, '1', {}, {
      success: function(data, textStatus, jqXHR) {
        jQuery.getJSON('/cart.js', function(cart) {
          updateCartDrawer();
        });          
      },
      error: function(jqXHR, textStatus, errorThrown) {
        console.log("Error: " + errorThrown + "!");
      },
    });
  });
});